<template>
  <div class="container">
    <h1>Edit Automation</h1>
    <div class="container has-text-left" v-if="automation">
      <div class="level">
        <div class="level-right">
          <div class="level-item">
            <b-switch v-model="enabled" true-value="1" false-value="0">{{labelEnabled}}</b-switch>
          </div>
          <div class="level-item">
            <b-switch v-model="silent" true-value="0" false-value="1">{{labelSilent}}</b-switch>
          </div>
          <div class="level-item">
            <b-button class="is-small" type="is-primary" @click="handleClickDuplicate">Duplicate
            </b-button>
          </div>
        </div>
      </div>
      <b-tabs v-model="activeTab">
        <b-tab-item label="Basic">
          <div class="block">
            <b-field label="Name">
              <b-input
                  v-model="automation.name"
                  placeholder="Enter user friendly name..."
                  required
              />
            </b-field>
          </div>
          <div class="block">
            <b-field label="Cooldown">
              <b-input
                  v-model="automation.cooldown"
                  placeholder="Cooldown in seconds..."
              />
            </b-field>
          </div>
        </b-tab-item>
        <b-tab-item :label="labelEvents">
          <div class="block">
            <b-field label="Events">
              <b-input v-model="strEvents" type="textarea"/>
            </b-field>
          </div>
        </b-tab-item>
        <b-tab-item :label="labelSchedules">
          <div class="block">
            <b-field label="Schedules">
              <b-input v-model="strSchedules" type="textarea"/>
            </b-field>
          </div>
        </b-tab-item>
        <b-tab-item :label="labelConditions">
          <div class="block">
            <b-field label="Conditions">
              <b-input v-model="strConditions" type="textarea"/>
            </b-field>
          </div>
        </b-tab-item>
        <b-tab-item :label="labelActions">
          <div class="block">
            <b-field label="Actions">
              <b-input v-model="strActions" type="textarea"/>
            </b-field>
          </div>
        </b-tab-item>
      </b-tabs>
      <div class="buttons">
        <b-button type="is-primary" class="is-outlined" @click="handleBack">Back</b-button>
        <b-button type="is-danger" class="is-outlined" @click="handleDelete">Delete</b-button>
        <b-button
            type="is-success"
            :disabled="!validFields() || !areThereAnyChanges()"
            @click="handleSave"
        >Save
        </b-button>
      </div>
      <div class="spacer"></div>
      <app-automation-log :id="this.automation.id"/>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import BSwitch from "buefy/src/components/switch/Switch";
  import BTabs from "buefy/src/components/tabs/Tabs";
  import BTabItem from "buefy/src/components/tabs/TabItem";
  import AutomationLog from "../components/configure/AutomationLog";

  export default {
    name: "screenconfigureautomation",
    components: {
      BTabItem,
      BTabs,
      BSwitch,
      BButton,
      BInput,
      BField,
      appAutomationLog: AutomationLog
    },
    data() {
      return {
        initialAutomation: null,
        automation: null,
        initialStrEvents: '[]',
        strEvents: '[]',
        initialStrSchedules: '[]',
        strSchedules: '[]',
        initialStrConditions: '{}',
        strConditions: '{}',
        initialStrActions: '[]',
        strActions: '[]',
        enabled: "1",
        silent: "0",
        loaded: false,
        activeTab: 0
      };
    },
    watch: {
      enabled(value) {
        if (this.loaded) {
          this.enableAutomation({
            id: parseInt(this.$route.params.id),
            enabled: parseInt(value)
          });
        }
      },
      silent(value) {
        if (this.loaded) {
          this.silentAutomation({
            id: parseInt(this.$route.params.id),
            silent: parseInt(value)
          });
        }
      }
    },
    computed: {
      ...mapGetters('automations', ['automationById']),
      labelEnabled() {
        return parseInt(this.enabled) === 1 ? 'Enabled' : 'Disabled';
      },
      labelSilent() {
        return parseInt(this.silent) === 1 ? 'Silent' : 'Will notify';
      },
      labelEvents() {
        if (!this.automation || !this.automation.definition) {
          return 'Events';
        }

        const { definition: { events } } = this.automation;
        if (events.length > 0) {
          return `Events (${events.length})`;
        }

        return 'Events';
      },
      labelSchedules() {
        if (!this.automation || !this.automation.definition) {
          return 'Schedules';
        }

        const { definition: { schedules } } = this.automation;
        if (schedules.length > 0) {
          return `Schedules (${schedules.length})`;
        }

        return 'Schedules';
      },
      labelConditions() {
        if (!this.automation || !this.automation.definition) {
          return 'Conditions';
        }

        const { definition: { conditions } } = this.automation;
        if (conditions) {
          if (conditions.length > 0) {
            return `Conditions (${conditions.length})`;
          } else if (Object.keys(conditions).length > 0) {
            return `Conditions (${Object.keys(conditions).length})`;
          }
        }

        return 'Conditions';
      },
      labelActions() {
        if (!this.automation || !this.automation.definition) {
          return 'Actions';
        }

        const { definition: { actions } } = this.automation;
        if (actions.length > 0) {
          return `Actions (${actions.length})`;
        }

        return 'Actions';
      }
    },
    methods: {
      ...mapActions('automations', ['deleteAutomation', 'enableAutomation', 'modifyAutomation', 'silentAutomation', 'duplicateAutomation']),
      validEvents() {
        try {
          JSON.parse(this.strEvents);
        } catch (e) {
          return false;
        }

        return true;
      },
      validSchedules() {
        try {
          JSON.parse(this.strSchedules);
        } catch (e) {
          return false;
        }

        return true;
      },
      validConditions() {
        try {
          JSON.parse(this.strConditions);
        } catch (e) {
          return false;
        }

        return true;
      },
      validActions() {
        try {
          JSON.parse(this.strActions);
        } catch (e) {
          return false;
        }

        return true;
      },
      validFields() {
        if (!this.automation || !this.automation.name) {
          return false;
        }
        if (this.automation.name.length < 1) {
          return false;
        }
        if (!this.validEvents() || !this.validSchedules() || !this.validConditions() || !this.validActions()) {
          return false;
        }
        return true;
      },
      areThereAnyChanges() {
        return JSON.stringify(this.initialAutomation) !== JSON.stringify(this.automation) ||
          this.initialStrEvents !== this.strEvents ||
          this.initialStrSchedules !== this.strSchedules ||
          this.initialStrConditions !== this.strConditions ||
          this.initialStrActions !== this.strActions;
      },
      handleBack() {
        this.$router.push('/configure/automations');
      },
      handleDelete() {
        if (confirm('Are you sure ?')) {
          this.deleteAutomation(this.$route.params.id);
          this.handleBack();
        }
      },
      handleSave() {
        try {
          const events = JSON.parse(this.strEvents);
          const schedules = JSON.parse(this.strSchedules);
          const conditions = JSON.parse(this.strConditions);
          const actions = JSON.parse(this.strActions);
          const data = {
            name: this.automation.name,
            cooldown: this.automation.cooldown,
            events,
            schedules,
            conditions,
            actions
          };
          this.modifyAutomation({
            id: parseInt(this.$route.params.id),
            data: data
          });
        } catch (e) {
          /* eslint-disable */
          console.log(e);
        }
      },
      handleClickDuplicate(id) {
        if (confirm('Are you sure you want to duplicate it ?')) {
          this.duplicateAutomation({
            id: this.$route.params.id
          });
        }
      },
    },
    mounted() {
      const that = this;
      this.initialAutomation = this.automationById(this.$route.params.id);
      this.automation = { ...this.initialAutomation };
      this.initialStrEvents = JSON.stringify(this.automation.definition.events, null, 2);
      this.strEvents = this.initialStrEvents;
      this.initialStrSchedules = JSON.stringify(this.automation.definition.schedules, null, 2);
      this.strSchedules = this.initialStrSchedules;
      this.initialStrConditions = this.automation.definition.conditions ? JSON.stringify(this.automation.definition.conditions, null, 2) : '{}';
      this.strConditions = this.initialStrConditions;
      this.initialStrActions = JSON.stringify(this.automation.definition.actions, null, 2);
      this.strActions = this.initialStrActions;
      this.enabled = parseInt(this.initialAutomation.disabled) === 0 ? "1" : "0";
      this.silent = parseInt(this.initialAutomation.silent) === 1 ? "1" : "0";
      setTimeout(() => {
        that.loaded = true;
      }, 900);
    }
  }
</script>

<style scoped>
  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .container {
    margin-top: 1rem;
  }

  .spacer {
    width: 100%;
    height: 2rem;
  }

  .block {
    margin-top: 1.25rem;
  }
</style>